import { CrossMd, paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import { mediaGalleryModalId } from '../../MediaGalleryModal';
import { MediaItemV2 } from '../../../../../app-kit/components/Image/types';
import { SwiperSlide } from 'swiper/react';
import { MediaGalleryCarouselSlide } from '../MediaGalleryCarouselSlide/MediaGalleryCarouselSlide';
import { styled } from 'styled-components';
import { MediaGalleryControls } from '../MediaGalleryControls/MediaGalleryControls';
import { MediaGalleryCarouselContextProvider } from '../../../../contexts/MediaGalleryCarouselContext/MediaGalleryCarouselContext';
import { MediaGalleryTimelineData } from '../MediaGalleryTimeline/MediaGalleryTimeline';
import { MediaCount } from '../../../MediaCountButtonsV2/MediaCountButtonsV2';
import { IMediaGalleryModal } from '../../../../contexts/MediaGalleryModalContext/MediaGalleryModalContext';

const Wrapper = styled.div`
  min-width: 0;
  position: relative;
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: hidden;
`;

const ModalCloseButton = styled.button`
  z-index: 10;
  position: absolute;
  top: ${spacingHelper('small')};
  right: ${spacingHelper('small')};
  color: ${paletteHelper('textInverted')};
  width: ${spacingHelper('extraLarge')};
  height: ${spacingHelper('extraLarge')};
  display: flex;
  justify-content: center;
  align-items: center;
  stroke-width: 1.2;
  background-color: ${paletteHelper('backgroundTertiaryInvertedStatic')};
  border-radius: 50%;
  border: 2px solid transparent;
  outline: none;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      border-color: transparent;
      background: ${paletteHelper('backgroundHoveredTertiaryInvertedStatic')};
    }
  }
  &:focus-visible {
    background: inherit;
    border-color: ${paletteHelper('borderFocusedInvertedStatic')};
  }
  &:active {
    background: ${paletteHelper('backgroundPressedTertiaryInvertedStatic')};
    border-color: transparent;
  }
`;

interface MediaGalleryCarouselProps {
  opened: boolean;
  onClose: () => void;
  mediaButtonCounts: Array<MediaCount>;
  galleryItems: Array<MediaItemV2>;
  timeline: MediaGalleryTimelineData[];
  initialSlideIndex: number;
  openAction: IMediaGalleryModal['openAction'];
}

export const MediaGalleryCarousel: FunctionComponent<MediaGalleryCarouselProps> = ({
  opened,
  onClose,
  mediaButtonCounts,
  galleryItems,
  timeline,
  initialSlideIndex,
  openAction,
}) => {
  if (!opened) return null;

  return (
    <Wrapper>
      <ModalCloseButton
        onClick={onClose}
        aria-label="Close Gallery"
        aria-expanded={opened}
        aria-controls={mediaGalleryModalId}
      >
        <CrossMd />
      </ModalCloseButton>
      <MediaGalleryCarouselContextProvider
        initialSlideIndex={initialSlideIndex}
        openAction={openAction}
        galleryItems={galleryItems}
      >
        {galleryItems.map((item, index) => (
          <SwiperSlide key={`${item.key}-${index}`} virtualIndex={index}>
            <MediaGalleryCarouselSlide mediaItem={item} />
          </SwiperSlide>
        ))}
        <MediaGalleryControls
          mediaButtonCounts={mediaButtonCounts}
          timeline={timeline}
          galleryItems={galleryItems}
        />
      </MediaGalleryCarouselContextProvider>
    </Wrapper>
  );
};
